import { render, staticRenderFns } from "./BaseProductTileName.vue?vue&type=template&id=92534dec&"
import script from "./BaseProductTileName.vue?vue&type=script&lang=js&"
export * from "./BaseProductTileName.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../sfra-webpack-builder/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/salesforce/sfra-webpack-builder/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('92534dec')) {
      api.createRecord('92534dec', component.options)
    } else {
      api.reload('92534dec', component.options)
    }
    module.hot.accept("./BaseProductTileName.vue?vue&type=template&id=92534dec&", function () {
      api.rerender('92534dec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app_byl_core/cartridges/app_byl_core/cartridge/client/default/js/vue/components/BaseProductTileName.vue"
export default component.exports